import {prepareOrganizationInvitation} from "./utils/organizationInviteLink.js";
import {prepareRecoveryLink} from "./utils/recoveryLink.js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./styles.css";
import "./theme.css";
import "./landing.css";
import "./features.css";
import { showWadeSignature } from "./utils/wadeSignature.js";

prepareRecoveryLink();
prepareOrganizationInvitation();
showWadeSignature();

const root = import.meta.hot?.data.root || createRoot(document.getElementById("root"));
if (import.meta.hot) import.meta.hot.data.root = root;
root.render(<React.StrictMode><App /></React.StrictMode>);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
